import axiosInstance from '../helpers/axios';

export const userService = {

    login,
    loginOtp,
    logout,
    getMe,
    sendOtp,
    fetchInprogressUsers,
    fetchInsubmissionUsers,
    fetchIndisbursedUsers,
    fetchInpendingdisbursment,
    fetchInsanction,
    fetchInrejected,
    fetchInreview,
    fetchDropped,
    fetchReadytodisburse,
    fetchOnholdusers,
    fetchDatefilter,
    fetchHandleuser,
    fetchHandlcoappuser,
    fetchEditformdetails,
    fetchDisbursedstatuschange,
    fetchDroppedstatuschange,
    fetchUpdateStatusUrl,
    fetchReviewstatuschange,
    updateEditformdetails,
    handleApproveFormdetails,
    fetchhandleApproveapi,
    fetchColenderFundSource,
    fetchfundcode,
    fetchUrlapproveapifund,
    getAadharfront,
    getAadharback,
    getPandetails,
    addCoApplicant,
    fetchUrlforbankselfie,
    fetchUrlforApplicationdetails,
    fetchEmiUrl,
    getBankSelfieDetails,
    getPanStatus,
    getCkycDetails,
    getDigiLocker,
    getProfileDetails,
    getUploadedFiles,
    getCibilDetails,
    getActivity,
    submitActivity,
    getPanProStatus,
    fetchLoans,
    fetchRepayments,
    fetchSoftPullDetails,

    postIncomePdf,
    getIncomeProfileAnalytics,
    postFoirDetails,
    getFoirDetails,
    getInstituteInfo,
    createProduct,
    getProductList,
    updatingBankDetails,
    updateBankdetails,
    updateInstitutedetails,
    callBankdetails,callbankdetails,
    callRegdetails,
    createInstitute,
    userSearch,
    userSearchdefault,
    userSearchInst,
    fetchLoanDetails,
    fetchLoansCount,

    fetchCallDetails,
    generateManualPaymentReceipt,
    createReminder,
    getNotifications,
    getEmiHistory,
    uploadFile,
    getReminder,
    reportdetails,

    fetchInstitutes,
    createApplication,
    createBijayApplication,
    deleteReminder,
    fetchProducts,
    fetchfiltereddata,

    getCustomerDashboard,
    getRules,
    getRuleVersions,
    previewRuleImpact,
    saveRuleThresholds,
    rollbackRule,


  };


async function getMe() {
    const res = await axiosInstance.get('/auth/me');
    return res?.data?.data;
}

// RINUX rules editor. Errors are not caught here, so the page can show the backend's message (409 / 422)
async function getRules(policyId) {
    const res = await axiosInstance.get(`/admin/rules/${policyId}`);
    return res?.data?.data;
}

async function getRuleVersions(policyId) {
    const res = await axiosInstance.get(`/admin/rules/${policyId}/versions`);
    return res?.data?.data;
}

async function previewRuleImpact(policyId, patches) {
    const res = await axiosInstance.post(`/admin/rules/${policyId}/impact`, { patches });
    return res?.data?.data;
}

async function saveRuleThresholds(policyId, patches, override) {
    const res = await axiosInstance.put(`/admin/rules/${policyId}/thresholds`, { patches, override });
    return res?.data?.data;
}

async function rollbackRule(policyId, version, reason) {
    const res = await axiosInstance.post(`/admin/rules/${policyId}/rollback/${version}`, { reason });
    return res?.data?.data;
}

async function login(emailId, password) {

    const payLoad = {
        emailId : emailId,
        password : password
    }

    const user =  axiosInstance.post(`/auth/verify`,payLoad)
    .then((res) => {
        return res?.data
    })
    .catch((err) => {
      alert("Invalid Username or password")

        return err
    });


    return user;
}
async function sendOtp(mobile) {
  
    const payLoad = {
        mobile:mobile
    }
    
    const user =  axiosInstance.post(`/auth/send-otp`,payLoad)
    .then((res) => {
        alert("OTP is sent to "+ mobile)
    })
    .catch((err) => {
      alert("Check Mobile Number / Server Down")
        
        return err
    });
    

    return user;
}
async function loginOtp(email, otp) {

    const payLoad = {
        emailId : email,
        otp : otp
    }

    const user =  axiosInstance.post(`/auth/verify-email-login-cookie`, payLoad)
    .then((res) => {
        return res?.data
    })
    .catch((err) => {
      alert("Invalid Username or otp")

        return err
    });


    return user;
}


  async function logout() {
    await axiosInstance.post('/auth/logout').catch(() => {});
  }


  async function fetchInprogressUsers(url, user) {
  
    
    
    const response =await axiosInstance.get(url,{
      headers : {
        'Content-type': 'application/json',
        
      }
    })
    .then((res) => {
        return res?.data?.data
    })
    .catch((err) => {
        
        return err
    });
    

    return response;
}

async function fetchInsubmissionUsers(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchIndisbursedUsers(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchInpendingdisbursment(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchInsanction(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchInrejected(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchInreview(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}
  
async function fetchDropped(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}
  

async function fetchReadytodisburse(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchOnholdusers(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchDatefilter(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      
      return res?.data?.data
  })
  .catch((err) => {
  //  alert(err?.response?.data?.message)
   setTimeout(() => window.location.reload(true), 100);
      
      return err
  });
  

  return response;
}

async function fetchHandleuser(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchHandlcoappuser(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      
      return res?.data?.data
  })
  .catch((err) => {
    // alert(err?.response?.data?.message)
      
      return err
  });
  

  return response;
}



async function fetchEditformdetails(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers:{
    }
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchDisbursedstatuschange(url,data, user) {
  
    
    
  const response =  axiosInstance.post(url,data,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {

    
      return res?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchDroppedstatuschange(url,data, user) {
  
    
    
  const response =  axiosInstance.post(url,data,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
    
    
      return res?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchUpdateStatusUrl(url,data, user) {
  
    
    
  const response =  axiosInstance.post(url,data,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}
async function fetchReviewstatuschange(url,data, user) {
  
    
    
  const response =  axiosInstance.post(url,data,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function updateEditformdetails(url,data, user) {
  
    
    
  const response =  axiosInstance.post(url,data,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function handleApproveFormdetails(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
    
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchhandleApproveapi(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchColenderFundSource(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchfundcode(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchUrlapproveapifund(url, user) {
  
    
    
  const response =  axiosInstance.get(url,{
    headers: {
      'Content-type': 'application/json',
    },
  })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function getAadharfront(url,data) {
  
    
    
  const response =  axiosInstance.post(url,data,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function getAadharback(url,data) {
  
    
    
  const response =  axiosInstance.post(url,data,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}
async function getPandetails(url,data) {
  
    
    
  const response =  axiosInstance.post(url,data,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function addCoApplicant(url,data,user) {
  
    
    
  const response =  axiosInstance.post(url,data,user,{
        headers: {
          'Content-type': 'application/json',
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}

async function fetchUrlforbankselfie(url,user) {
  
    
    
  const response =  axiosInstance.get(url,{
        headers: {
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      // alert(err?.response?.data?.message)
      return err
  });
  

  return response;
}
async function fetchUrlforApplicationdetails(url,user) {
  
    
    
  const response =  axiosInstance.get(url,{
        headers: {
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
    // alert(err?.response?.data?.message)
      
      return err
  });
  

  return response;
}
async function fetchEmiUrl(url,user) {
  
    
    
  const response =  axiosInstance.get(url,{
        headers: {
        },
      })
  .then((res) => {
      return res?.data?.data
  })
  .catch((err) => {
      
      return err
  });
  

  return response;
}
 async function getCkycDetails(url,user){

       const response= await axiosInstance.get(url, {
               headers: {
                  'Content-type': 'application/json',
                                },
           }).then((res) => {
            
               if(res.data.data==null || ( typeof res.data.data.response==='string'|| res.data.data.response instanceof String))
              {
                 
                  return false
              } 
               else
               return res.data.data.response;
                         
         })
         .catch((err)=>{return err})

         return response
    }
  
    async function getDigiLocker(url,user){
      const response =await axiosInstance.get(url, {
               headers: {
                  'Content-type': 'application/json',
               },
           }).then((res) => {
                          
               if(res?.data?.data!=null)
                  return res?.data?.data;
             
                              
         })
         .catch((err)=>{return err})

         return response;

    }
    async function getPanStatus(url){
       
      
      const response= await axiosInstance.get(url).then((res) => {
                          
               if(res.data.data.length>0)
               {
                 return res.data.data.find(obj => {
                return obj.document===2 
                  })
                }
              
               }
       )
         .catch((err)=>{
        //  alert(err?.response?.data?.message)
          return err})
       

       return response
  
    }

    async function getPanProStatus(url,data,user){
       
      
      const response= await axiosInstance.post(url,data,{
        headers: {
        },
      }).then((res) => {
                          
              return res?.data?.data
              
               }
       )
         .catch((err)=>{return err})
       

       return response
  
    }


    async function getBankSelfieDetails(url,user){
      const response=await  axiosInstance.get(url, {
                   headers: {
                     'Content-type': 'application/json',
                          },
             }).then((res) => {
                         
                      return{
                        bankDetails:res?.data?.data?.bankDetails,
                        selfieDetails:res?.data?.data?.selfieDetails,
                      facematchDetails:res?.data?.data?.facematchDetails
                      }

         })
         .catch((err)=>{return err})


         return response
    }

    async function getProfileDetails(url) {

      const response=await axiosInstance.get(url)
      .then((res)=>{
        return res.data
      })
      .catch((err)=>{
        // alert(err?.response?.data?.message)
        return err
      })

      return response
      
    }

    async function getUploadedFiles(url,user){

      const response =await axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })

      return response

    }

    async function getCibilDetails(url) {
      const response=await axiosInstance.get(url)
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err
      })
      

      return response
    }
    async function fetchSoftPullDetails(url) {
      const response=await axiosInstance.get(url)
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err
      })
      

      return response
    }
    async function getActivity(url) {
      const response=await axiosInstance.get(url)
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err
      })
      

      return response
    }
    
    //post activity
    async function submitActivity(url,body,user) {
      const response=await axiosInstance.post(url,body,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err
      })
      

      return response
    }

    async function postIncomePdf(url,body,user) {

      const response=await axiosInstance.post(url,body,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err;
      })

      return response;
      
    }
    async function getIncomeProfileAnalytics(url,user) {

      const response=await axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err;
      })

      return response;
      
    }
    
    async function postFoirDetails(url,body,user) {

      const response=await axiosInstance.post(url,body,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err;
      })

      return response;
      
    }
    
    async function getFoirDetails(url,user) {

      const response=await axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err;
      })

      return response;
      
    }
    async function getInstituteInfo(url,user) {

      const response=await axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        return err;
      })

      return response;
      
    }
    async function createProduct(url,body,user) {

      const response=await axiosInstance.post(url,body,{
        headers:{
        }
      })
      .then((res)=>{
        return res;
      })
      .catch((err)=>{
        alert("Error while creating product. Please, Contact customer support!")
        return err;
      })

      return response;
      
    }
    
    async function fetchLoans(url, user) {
  
    
    
      const response =  axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res) => {
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;
    }
    async function fetchRepayments(url, user) {
  
    
    
      const response =  axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res) => {
          return res?.data?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;
    }

    async function getProductList(url,user){

      const response =await axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })

      return response
    }
    async function updatingBankDetails(url,obj4,user) {
  
    
      const response = axiosInstance.post(url,obj4,{
        headers:{
        }
      })
      .then((res) => {
        alert("Success")
    })
    .catch((err) => {
      alert("Error !")
        
    });
    return response
    }
    async function updateBankdetails(url,obj3,user) {
  
    
      const response = axiosInstance.post(url,obj3,{
        headers:{
        }
      })
      .then((res) => {
        alert("Bank Details Added")
        setTimeout(()=>{
          window.location.reload();
        },1000);})
    .catch((err) => {
      alert("Error in Bank Details!!!")    
    });
    return response
    }
    async function updateInstitutedetails(updateInstituteDetailsUrl,updateObj,user) {
  
    
      const response = axiosInstance.post(updateInstituteDetailsUrl,updateObj,{
        headers:{
        }
      })
      .then((res) => {
        alert("Details Updated")
        setTimeout(()=>{
          window.location.reload();
        },1000);})
    .catch((err) => {
      alert("Failed To Update Details Contact Team")
    });
    return response
    }
    
    async function callBankdetails(saveSqlBankDetailsUrl,obj4,user) {
  
    
      const response = axiosInstance.post(saveSqlBankDetailsUrl,obj4,{
        headers:{
        }
      })
      .then((res) => {
        alert("Success")
    })
    .catch((err) => {
      alert("Error !")
        
    });
    return response
    }
    async function callbankdetails(saveBankDetailsUrl,obj3,user) {
  
    
      const response = axiosInstance.post(saveBankDetailsUrl,obj3,{
        headers:{
        }
      })
      .then((res) => {
        alert("Bank Details Added")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
    .catch((err) => {
      alert("Error in Bank Details!!!")
        
    });
    return response
    }
    async function callRegdetails(b2bsignupURL,obj,user) {
  
    
      const response = axiosInstance.post(b2bsignupURL,obj,{
        headers:{
        }
      })
      .then((res) => {
      })
    .catch((err) => {
     alert("Error ! Check Fields")
        
    });
    return response
    }
    async function createInstitute(createUrl,obj2,user) {
  
    
      const response = axiosInstance.post(createUrl,obj2,{
        headers:{
        }
      })
      .then((res) => {
        alert("Institute Details Added")
      })
    .catch((err) => {
      alert('Error ! Check Fields')
        
    });
    return response
    }
    async function userSearch(sanctionUrl,navigate,status,user) {
  
    
      const response =await axiosInstance.get(sanctionUrl,{
        headers:{
        }
      })
      .then((res) => {
        if(res.data.data!==null){
          if(status==='Pending Disbursement')
          {
            navigate(`/status/Pending`)
          }
          else if(status==='In Sanction')
          {
            navigate(`/status/Sanction`)
          
          }
          else if(status==='Ready to Disburse')
          {
            navigate(`/status/disbursement`)
          }
          else if(status==='In Process')
          {
            navigate(`/status/Process`)
          }
        }
     
        return res;
      })
    .catch((err) => {
      return err
        
    });
    return response
    }
    async function userSearchdefault(getAppUrl,status,navigate,user) {
  
    
      const response =await axiosInstance.get(getAppUrl,{
        headers:{
        }
      })
      .then((res) => {
        if(res?.data?.data!==null)
        {
            if(status==='In Submission')
          {
            navigate(`/Status/submission`)
          }
          else if(status==='In Review')
          {
            navigate(`/Status/review`)
          
          }
          else if(status==='Disbursed')
          {
            navigate(`/Status/disbursed`)
          }
          else if(status==='Rejected')
          {
            navigate(`/Status/rejected`)
          }
          else if(status==='Dropped')
          {
            navigate(`/Status/dropped`)
          }
          else if(status==='On Hold')
          {
            navigate(`/Status/Hold`)
        }
        }
       return res
      })
    .catch((err) => {
      return err
        
    });
    return response
    }
    async function userSearchInst(urlUsers,status,navigate,user) {
  
    
      const response =await axiosInstance.get(urlUsers,{
        headers:{
        }
      })
      .then((res) => {
        if(res?.data?.data!==null)
        {
            if(status === "In Process" || status === "In Submission" || status === "In Review" || status === "In Sanction" || status === "In Disbursement" || status === "Ready to Disburse")
          {
            navigate(`/applications`)
          }
          
          else if(status==='Disbursed')
          {
            navigate(`/Status/disbursed`)
          }
          else if(status==='Rejected')
          {
            navigate(`/Status/rejected`)
          }
          else if(status==='Dropped')
          {
            navigate(`/Status/dropped`)
          }
          else if(status==='On Hold')
          {
            navigate(`/Status/Hold`)
        }
        }
       return res
      })
    .catch((err) => {
      return err
        
    });
    return response
    }
    async function fetchLoanDetails(url, user) {
  
    
    
      const response =  axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res) => {
        
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;
    }
    async function fetchLoansCount(url, user) {
  
    
    
      const response =  axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res) => {
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;
    }

    async function fetchCallDetails(url, user) {
  
    
    
      const response =  axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res) => {
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;

    }
    async function getNotifications(url) {

      const response=await axiosInstance.get(url)
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })
      
      return response

    }
    async function generateManualPaymentReceipt(url,user,body) {

      const response=await axiosInstance.post(url,body,{
        headers:{
        }  
      })
      .then((res)=>{
        alert(res?.data?.message)
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        return res
      })
      .catch((err)=>{
        alert(err?.response?.data?.message)
        return err
      })
      
      return response

    }
    async function createReminder(url,body,user) {

      const response=await axiosInstance.post(url,body,{
        headers:{
        }
      })
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })
      
      return response

    }
    async function getEmiHistory(url,user) {

      const response=await axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })
      
      return response

    }
    async function uploadFile(url,body) {

      const response=await axiosInstance.post(url,body)
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })
      
      return response

    }
    async function getReminder(url) {

      const response=await axiosInstance.get(url)
      .then((res)=>{
        return res
      })
      .catch((err)=>{
        return err
      })
      
      return response

    }
    async function reportdetails(urlUsers,data, user) {
  
    
    
      const response =  axiosInstance.post(urlUsers,data,{
        headers:{
        }
      })
      .then((res) => {
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;

    }

    async function fetchInstitutes(getinst, user) {
  
    
    
      const response =  axiosInstance.get(getinst,{
        headers:{
        }
      })
      .then((res) => {
        
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;

    }
     async function deleteReminder(url,body,user) {
      const response=await axiosInstance.delete(url,{
        
        headers:{
        },
        data:body
      })
      .then((res)=>{
       
        return res
      })
      .catch((err)=>{

        return err
        
      })
      
      return response


    }

    async function fetchProducts(getinst, user) {
  
    
    
      const response =  axiosInstance.get(getinst,{
        headers:{
        }
      })
      .then((res) => {
        
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;

    }
    async function fetchfiltereddata(url, user) {
  
    
    
      const response =  axiosInstance.get(url,{
        headers:{
        }
      })
      .then((res) => {
          return res?.data?.data
      })
      .catch((err) => {
          
          return err
      });
      
    
      return response;
    }


    async function createBijayApplication(url, body, user, arr) {
      try {
        // First API call
        const response = await axiosInstance.post(url, body, {
          headers: {
          },
        });
    
       window.dispatchEvent(new CustomEvent('feemonk-app-created', { detail: { message: 'Application created — Status: In Submission', type: 'success' } }))
    
        const userId = response.data.data.userId;

        if (arr.length > 0) {
          arr.forEach((item) => {
            item.userId = response?.data?.data.userId;
          });
    
    
          const urlUploadDocs = '/users/documents/create/multiple';
    
          // Second API call with delay
          setTimeout(async () => {
            try {
              await axiosInstance.post(
                urlUploadDocs,
                arr.filter(
                  (item) =>
                    item.type !== "aadhaar" &&
                    item.type !== "pan" &&
                    (item.url1 !== "" || item.url2 !== "")
                ),
                {
                  headers: {
                  },
                }
              );
    
            } catch (err) {
            }
          }, 1000);
        }
    
        return response?.data?.data;
      } catch (err) {
        alert(
          err?.response?.data?.message
            .map((item) => ` ${item}\n`)
            .join("")
        );
        console.error(err);
      }
    }
    
    async function createApplication(url, body,user,arr, instituteId) {
  
      const response =  axiosInstance.post(url,body,{
        headers:{
        }
      })
      .then((res) => {
          window.dispatchEvent(new CustomEvent('feemonk-app-created', { detail: { message: 'Application created — Status: In Submission', type: 'success' } }))
          const userId = res.data.data.userId;
            if (userId) {
              const data2 = { userId ,
                        latitude : 0,
                        longitude : 0,};
        
              
              axiosInstance.post(`/end-user/submit/admin`, data2, { headers:{
                'Content-Type': 'application/json',
              } })
                .then(() => {
                  // if (arr.length <= 0) {
                  //   window.location.reload();
                  // }
                })
                .catch((error) => error);
            }
           if(arr.length>0)
      { 
       
        for(let i=0;i<arr.length;i++)
        {
          arr[i].userId=res?.data?.data.userId
        }
        
        const urlUploadDocs='/users/documents/create/multiple'
        setTimeout(() => {
          
          axiosInstance.post(urlUploadDocs,arr.filter(item=>(item.type!=="aadhaar"&&item.type!=="pan")&&(item.url1!==""||item.url2!=="")),{
            headers:{
            }
          })
          .then((res)=>{
          //  setTimeout(() => {
          //    window.location.reload();
          //  }, 1000);
          })
          .catch((err)=>{
          })
        }, 1000);
      }
          return res?.data?.data
      })
      .catch((err) => {
          alert(err?.response?.data?.message.map((item)=>{
            return(
              ` ${item}\n`
    
            )
          }))
          
      });
      
    
      return response;
    }






async function getCustomerDashboard(url, user, mob) {
  const payLoad = {
    mobile: mob,
  };

  const response = axiosInstance
    .post(url, payLoad, {
      headers: {
      },
    })
    .then((res) => {
      return res?.data;
    })
    .catch((err) => {
      ;
      return err;
    });

  return response;
}